var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Create new subscription",
            label: "Create subscription",
            disabled: _vm.isDisabledSubmit,
            submitLoading: _vm.submitLoading
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onSubmit
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-4 overflow-y-auto",
              style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
            },
            [
              _c(
                "div",
                { staticClass: "grid grid-cols-6 gap-4 px-8" },
                [
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-2 col-span-6 gap-4" },
                    _vm._l(_vm.typeOptions, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.value,
                          staticClass:
                            "px-5 py-5 text-center transition-all duration-300 rounded-lg cursor-pointer",
                          class: [
                            _vm.typeInput === opt.value
                              ? "border-light-purple"
                              : "border-slate-400"
                          ],
                          style: { borderWidth: "1.5px" },
                          on: {
                            click: function($event) {
                              _vm.typeInput = opt.value
                            }
                          }
                        },
                        [
                          _c("BlTextSubtitle3", {
                            class: [
                              _vm.typeInput === opt.value
                                ? "text-light-purple"
                                : "text-slate-700"
                            ],
                            attrs: { text: opt.label }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.typeInput === "Subscription::Custom"
                    ? _c("BlInputText", {
                        staticClass: "col-span-6",
                        attrs: { input: _vm.nameInput },
                        on: { changed: _vm.inputHandler }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput === "Subscription::Custom"
                    ? _c(
                        "div",
                        { staticClass: "relative col-span-3" },
                        [
                          _c("BlInputText", {
                            attrs: { input: _vm.amountInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "absolute bottom-0.5 right-0.5 px-0.5 py-0.5 bg-slate-200 border-l border-slate-400"
                            },
                            [
                              _c("BlSelectBox", {
                                staticClass: "bg-slate-200",
                                attrs: {
                                  dense: "",
                                  borderless: "",
                                  options: _vm.currencyOptions
                                },
                                on: {
                                  change: function($event) {
                                    _vm.currencyInput = $event
                                  }
                                },
                                model: {
                                  value: _vm.currencyInput,
                                  callback: function($$v) {
                                    _vm.currencyInput = $$v
                                  },
                                  expression: "currencyInput"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlInputText", {
                    class: {
                      "col-span-3": _vm.typeInput === "Subscription::Custom",
                      "col-span-6": _vm.typeInput === "Subscription::FreeTrial"
                    },
                    attrs: { input: _vm.seatsInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputDate", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.startDateInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputDate", {
                    staticClass: "col-span-3",
                    attrs: { input: _vm.expirationDateInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputText", {
                    staticClass: "col-span-6",
                    attrs: { input: _vm.notesInput },
                    on: { changed: _vm.inputHandler }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-shrink-0 h-5 bg-slate-200" }),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-2" },
                  [
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Manage features" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "The features will automatically adjust based on the settings configured when this subscription becomes active."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col gap-2" }, [
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.analyticsFeature = !_vm.analyticsFeature
                          }
                        }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.analyticsFeature },
                          on: {
                            changed: function($event) {
                              _vm.analyticsFeature = !_vm.analyticsFeature
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Analytics" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.appointmentsFeature = !_vm.appointmentsFeature
                          }
                        }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.appointmentsFeature },
                          on: {
                            changed: function($event) {
                              _vm.appointmentsFeature = !_vm.appointmentsFeature
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "Availabilities & appointments" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.branchesFeature = !_vm.branchesFeature
                          }
                        }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.branchesFeature },
                          on: {
                            changed: function($event) {
                              _vm.branchesFeature = !_vm.branchesFeature
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Branches" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.salesPipelinesFeature = !_vm.salesPipelinesFeature
                          }
                        }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.salesPipelinesFeature },
                          on: {
                            changed: function($event) {
                              _vm.salesPipelinesFeature = !_vm.salesPipelinesFeature
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Sales pipeline" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.sbtFeature = !_vm.sbtFeature
                          }
                        }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.sbtFeature },
                          on: {
                            changed: function($event) {
                              _vm.sbtFeature = !_vm.sbtFeature
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "Skill-based Treatment (SBT)" }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.overlappedOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Subscription period overlap detected",
                label: "Update and create subscription",
                disabled: _vm.isDisabledSubmit,
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  return _vm.$emit("close-modal")
                },
                "backdrop-action": _vm.onSubmit
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-3 px-8",
                  style: { width: "40rem" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: { text: "The subscription period for" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: _vm.nameInput.model }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: "overlaps with the current active period for"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: "" + _vm.currentSubscription.name }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: {
                          text:
                            "(" +
                            _vm.displayDate({
                              date: _vm.currentSubscription.start_date
                            }) +
                            " - " +
                            _vm.displayDate({
                              date: _vm.currentSubscription.expiration_date
                            }) +
                            ")."
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text: "Please select how you'd like to resolve this:"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex gap-2" },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          name: "shorten_current_subscription_period",
                          checked: _vm.shortenCurrentSubscriptionPeriod
                        },
                        on: {
                          changed: function($event) {
                            _vm.shortenCurrentSubscriptionPeriod = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: {
                              text: "Shorten current subscription period"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text: "The current active subscription"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: {
                                  text: "(" + _vm.currentSubscription.name + ")"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "will end early on" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.startDateInput.model
                                  })
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text: "to accommodate the new period."
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex gap-2" },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          name: "shorten_current_subscription_period",
                          checked: !_vm.shortenCurrentSubscriptionPeriod
                        },
                        on: {
                          changed: function($event) {
                            _vm.shortenCurrentSubscriptionPeriod = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: {
                              text: "Adjust new subscription start date"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Change the start date of the new subscription"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: { text: "(" + _vm.nameInput.model + ")" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "to prevent overlap with the existing active period."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-4" },
                            [
                              _c("BlInputDate", {
                                attrs: { input: _vm.overlappedStartDateInput },
                                on: { changed: _vm.inputHandler }
                              }),
                              _vm._v(" "),
                              _c("BlInputDate", {
                                attrs: {
                                  input: _vm.overlappedExpirationDateInput
                                },
                                on: { changed: _vm.inputHandler }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5790fba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5790fba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/subscription/NewSubscriptionModal.vue
// module id = null
// module chunks = 